<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><strong>Contents</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/intro#intro">Introduction</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch1#ch1">Human Error</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch2#ch2" title="Link target outside of Sample">Bet on Leadership</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch3#ch3" title="Link target outside of Sample">Second Chance</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch4#ch4" title="Link target outside of Sample">The Assignment</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch5#ch5" title="Link target outside of Sample">Our Point of View</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch6#ch6" title="Link target outside of Sample">That’s My Job</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch7#ch7" title="Link target outside of Sample">Study the Best</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch8#ch8" title="Link target outside of Sample">Scale Matters</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch9#ch9" title="Link target outside of Sample">The Big Idea</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">Let’s Review</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">It Just Happens</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">Just Do It</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">Never Too Late</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">Connect the Dots</span></p>
<p class="toc"><a id="page_viii"></a><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample">The Pitch</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch16#ch16" title="Link target outside of Sample">Decision Time</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/epi#epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><a id="page_1"></a><span class="nounder" href="#/xhtml/author#author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?005b1cec